import env from '../server/helpers/env'

import { pathPrefix } from '~/../__config__/env.json'

const prefix = () => pathPrefix[env] || ''

export default prefix
